/** Collapse presentation-only differences without changing Korean/Latin meaning. */
export function normalizeWhitespace(value: string): string {
  return value.normalize("NFKC").replace(/\s+/gu, " ").trim();
}

export function normalizeComparableText(value: string): string {
  return normalizeWhitespace(value)
    .toLocaleLowerCase("ko-KR")
    .replace(/[\p{P}\p{S}]+/gu, " ")
    .replace(/\s+/gu, " ")
    .trim();
}

function canonicalize(value: unknown): unknown {
  if (typeof value === "string") return normalizeWhitespace(value);
  if (typeof value === "number") {
    if (!Number.isFinite(value)) throw new TypeError("Non-finite numbers cannot be hashed.");
    return Object.is(value, -0) ? 0 : value;
  }
  if (value === null || typeof value === "boolean") return value;
  if (Array.isArray(value)) return value.map(canonicalize);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, item]) => item !== undefined)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, item]) => [key, canonicalize(item)]),
    );
  }
  if (value === undefined) return undefined;
  throw new TypeError(`Unsupported canonical value: ${typeof value}`);
}

export function stableStringify(value: unknown): string {
  return JSON.stringify(canonicalize(value));
}

export function sortUniqueStrings(values: readonly string[]): string[] {
  return [...new Set(values.map(normalizeWhitespace).filter(Boolean))].sort((a, b) =>
    a.localeCompare(b, "ko-KR"),
  );
}
